
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useFormatById from "src/hooks/utils/useFormatById";
import actions from "src/store/privacyPolicies/actions";

const PrivacyPolicies = () => {
  const f = useFormatById();
  const dispatch = useDispatch();

  const privacyPolicy = useSelector(state => state.privacyPolicies.privacyPolicy)

  useEffect(()=>{
    dispatch(actions.getPrivacyPolicies())
  },[])
  
  useEffect(() => {
    console.log(privacyPolicy)

  }, [privacyPolicy])
  

  return (
    <div className="container">
      <div className="mt-3">
      <h1 className="text-center mb-3">{f("breadCrumb.privacyPolicies")}</h1>
      { 
         privacyPolicy?.map((item)=> (
          <div key={item?.id} className="mb-4">
            <h5>{item?.title}</h5>
            <ul>
              {item?.sections.map(o => <li key={o.id}>{o.content}</li>)}
            </ul>
          </div>
          )
        )
      }
      </div>
    </div>
  );
};

export default PrivacyPolicies;
